var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-10-25
 * @brief EHPworkorder - EhealthCheck 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
//ex-utils
//datepicker
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import "react-datepicker/dist/react-datepicker.css";
import { ko, enUS, zhCN, } from "date-fns/esm/locale";
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
//component
import EhpPagination from "../../../common/pagination/EhpPagination";
import { useTrans } from "../../../../utils/langs/useTrans";
/**
 * @brief EHP WorkOrder - EhealthCheck 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function EhealthCheckList(props) {
    //trans
    const t = useTrans();
    const navigate = useNavigate();
    const mobileRef = useRef(null); // Mobile Check용
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isTreeOpen = props.isTreeOpen;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const setParentNodata = props.setNodata;
    const [isCount, setIsCount] = useState(false);
    const counteRef = useRef(null); // Mobile Check용
    //mobile check
    const [ehcList, setEhcList] = useState([]);
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(counteRef))
                return;
            const countTag = counteRef.current;
            if (!CUTIL.isnull(countTag)) {
                if ((countTag.clientHeight <= 0) && (countTag.clientWidth <= 0)) {
                    setIsCount(true);
                }
                else {
                    setIsCount(false);
                }
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (mobileRef.current) {
            if ((mobileRef.current.clientHeight <= 0) && (mobileRef.current.clientWidth <= 0)) {
                setIsCount(true);
            }
        }
    }), 100);
    //
    const [ehcCount, setEhcCount] = useState(null);
    //const [ehcList, setEhcList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10, "listReload": false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // date List
    // const exceptStartDate = new Date(new Date().setDate(new Date().getDate() - 365));
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const mintStartDate = dayjs(endDate).set("year", dayjs(endDate).year() - 1).toDate(); // 종료일 기준 1년
    const maxEndDate = dayjs(startDate).set("year", dayjs(startDate).year() + 1).toDate(); // 시작일 기준 1년
    const dateTypeList = [
        /*{"id":0, "dtDisp":"전체", "dtVal":""},*/
        { "id": 1, "dtDisp": t("FIELD.요청일자"), "dtVal": "requestDate" },
        { "id": 2, "dtDisp": t("FIELD.진행일자"), "dtVal": "handlingDate" },
        { "id": 3, "dtDisp": t("FIELD.완료일자"), "dtVal": "completionDate" },
    ];
    const [dateType, setDateType] = useState(dateTypeList[0]);
    const dateTermList = [
        { "id": 0, "dtDisp": (!isMobile) ? "직접입력" : t("LABEL.전체"), "dtVal": 0 },
        { "id": 1, "dtDisp": t("LABEL.T1개월", ["1"]), "dtVal": 30 },
        { "id": 2, "dtDisp": t("LABEL.T1개월", ["3"]), "dtVal": 90 },
        { "id": 3, "dtDisp": t("LABEL.T1개월", ["6"]), "dtVal": 180 },
        { "id": 4, "dtDisp": t("LABEL.T1년", ["1"]), "dtVal": 365 },
    ];
    const [dateTerm, setDateTerm] = useState(dateTermList[0]);
    //
    let appPath = "";
    if (selTree.zone.zoneId.length > 0) {
        appPath = appPath + `zoneId=${selTree.zone.zoneId}`;
    }
    if (selTree.subZone.subZoneId.length > 0) {
        appPath = appPath + `&subZoneName=${selTree.subZone.subZoneName}`;
    }
    ///
    const [searchCount, setSearchCount] = useState({
        "dateType": null,
        "dateTerm": null,
        "startDate": null,
        "endDate": null,
    });
    const [dateSel, setDateSel] = useState(null);
    // 검색 후 초기화 필요
    /*   function resetSearchCount(isAll) {
        clog("resetSearchCount : isMobile : " + isMobile);
        if (isAll) {
          setDateType((searchCount.dateType) ? searchCount.dateType : dateTypeList[0]);
          setDateTerm((searchCount.dateTerm) ? searchCount.dateTerm : dateTermList[0]);
          setStartDate(searchCount.startDate);
          setEndDate(searchCount.endDate);
        } else {
          if (!isMobile) { // mobile에서는 엑션이 밣생 안하도록 / term에서 액션이 발생 / dateKind 값 변경 시 select 초기화(전체)
            document.getElementById("mcheck_date_1").click();
            document.getElementById("mcheck_date_0").click();
            setDateTerm(dateTermList[0]);
            setStartDate(null);
            setEndDate(null);
          } else {
            document.getElementById("mcheck_date_1").click();
            document.getElementById("mcheck_date_0").click();
            setDateTerm(dateTermList[0]);
            setStartDate(null);
            setEndDate(null);
          }
        }
      } */
    if (searchCount.dateType && (searchCount.dateType.dtVal.length > 0)) {
        if ((!CUTIL.isnull(searchCount.startDate)) && (!CUTIL.isnull(searchCount.startDate))) {
            appPath = appPath
                + `&dateKind=${searchCount.dateType.dtVal}`
                + `&startDate=${CUTIL.date2formedstr(searchCount.startDate, "yyyyMMdd")}`
                + `&endDate=${CUTIL.date2formedstr(searchCount.endDate, "yyyyMMdd")}`;
        }
    }
    /////////////////
    const [serviceStatus, setServiceStatus] = useState(""); //"":ALL, Requested, accepted, ing, done
    const searchFieldList = [
        //{"id":0, "sfDisp":"전체", "sfVal":""},
        { "id": 1, "sfDisp": t("FIELD.기기명"), "sfVal": "spgName" },
        { "id": 2, "sfDisp": t("FIELD.Panel명"), "sfVal": "panelName" },
        { "id": 3, "sfDisp": t("FIELD.시리얼번호"), "sfVal": "serialNo" },
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchData] = useState({
        "searchField": null,
        "searchText": null,
    });
    const [fieldList, setFieldList] = useState([
        { "id": 0, "fdDisp": "상태", "fdVal": "progressStatus", "sort": "asc", "click": false },
        { "id": 1, "fdDisp": "점검단계", "fdVal": "ehcStatus", "sort": null, "click": false },
        { "id": 2, "fdDisp": "요청 일자", "fdVal": "requestDate", "sort": "asc", "click": false },
        { "id": 3, "fdDisp": "기기명", "fdVal": "spgName", "sort": "asc", "click": false },
        { "id": 4, "fdDisp": "Panel 명", "fdVal": "panelName", "sort": "asc", "click": false },
        { "id": 5, "fdDisp": "시리얼 번호", "fdVal": "serialNo", "sort": "asc", "click": false },
        { "id": 6, "fdDisp": "담당자", "fdVal": "responsible", "sort": null, "click": false },
        { "id": 7, "fdDisp": "Report", "fdVal": "", "sort": null, "click": false },
        { "id": 8, "fdDisp": "진행 일자", "fdVal": "handlingDate", "sort": "asc", "click": false },
        { "id": 9, "fdDisp": "완료 일자", "fdVal": "completionDate", "sort": "asc", "click": false },
    ]);
    function handleServiceStatus(status) {
        if (isMobile) {
            if (serviceStatus === status) {
                setServiceStatus("");
            }
            else {
                setServiceStatus(status);
            }
        }
        else {
            setServiceStatus(status);
        }
        handleCurPage(0);
        setSearchText("");
        setSearchData({
            "searchField": null,
            "searchText": null,
        });
    }
    //검색 카운트별 검색 전체/요청/...
    let listPath = appPath;
    listPath = listPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (serviceStatus.length > 0) {
        listPath = listPath + `&serviceStatus=${serviceStatus}`;
    }
    //text검색
    if (searchData.searchField) {
        if (searchData.searchField.sfVal.length > 0) {
            listPath = listPath + `&searchKind=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
        }
    }
    //필드 정렬
    fieldList.filter(fd => fd.click && fd.sort).map((fd) => {
        listPath = listPath + `&sort=${fd.fdVal},${fd.sort}`;
    });
    useEffect(() => {
        // param 초기화
        let today = new Date();
        const startdate = new Date(new Date().setDate(today.getDate() - 365));
        document.getElementById("mcheck_date_1").click();
        document.getElementById("mcheck_date_4").click();
        setSearchCount({
            "dateType": dateType,
            "dateTerm": dateTerm,
            "startDate": startdate,
            "endDate": today,
        });
        setSearchText("");
        setSearchData({
            "searchField": null,
            "searchText": null,
        });
        setServiceStatus("");
        setSearchField(searchFieldList[0]);
        setSearchText("");
        setSearchData({
            "searchField": null,
            "searchText": null,
        });
        //handleCurPage(0);
        setPageInfo(defaultPageInfo);
        /*
          
        */
    }, [selTree]);
    // dateKind 선택 시 초기화
    useEffect(() => {
        let today = new Date();
        const startdate = new Date(new Date().setDate(today.getDate() - 365));
        document.getElementById("mcheck_date_1").click();
        document.getElementById("mcheck_date_4").click();
        setSearchCount({
            "dateType": dateType,
            "dateTerm": dateTerm,
            "startDate": startdate,
            "endDate": today,
        });
        handleCurPage(0);
        setSearchText("");
        setSearchData({
            "searchField": null,
            "searchText": null,
        });
    }, [dateType]);
    const [listReload, setListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/workorder/count?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + listReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
            if (ERR_URL.length > 0) {
                navigate(ERR_URL);
            }
            //setRecoilIsLoadingBox(false);
            //clog("IN WF EHC COUNT : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setEhcCount(retData.body);
                /*
                (async () => { // IFFE(Immediately Invoked Function Expression)은 함수가 정의되자마자 실행되는 자바스크립트 기술입니다.
                  let data: any = null;
                  //setRecoilIsLoadingBox(true);
                  data = await HTTPUTIL.PromiseHttp({
                    "httpMethod": "GET",
                    //"appPath": `/api/v2/product/company/zone/subzone/room/panel/item/workorder?page=${pageInfo.number}&size=${pageInfo.size}&${listPath}`,
                    "appPath": `/api/v2/product/company/zone/subzone/room/panel/item/workorder?${listPath}`,
                    appQuery: {
                      //"serviceStatus":serviceStatus,
                    },
                    userToken: userInfo.loginInfo.token,
                    //watch : listPath // useEffect에 조건을 달았음...
                  });
        
                  if (data) {
                    setRecoilIsLoadingBox(false);
                    const ERR_URL = HTTPUTIL.resultCheck(false, data);
                    if (ERR_URL.length > 0) {
                      CUTIL.sleep(500);
                      navigate(ERR_URL);
                    }
                    if (data.codeNum == CONST.API_200) {
                      clog("IN WF EHC LIST : RES : " + JSON.stringify(data.data.page));
                      setEhcCount(retData.body);
                      resetSearchCount(true); // reset
                      setEhcList(data.body);
                      setPageInfo({ ...data.data.page, psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false },); //5, 10
                      setParentNodata(data.data.page.totalElements);
                    } else { // api if
                      // need error handle -> goto system error page?
                      setErrorList(data.body.errorList);
                      alert(JSON.stringify(data.body.errorList));
                    }
                  }
                })();
                */
            }
            else {
                setErrorList(retData.body.errorList);
                alert(JSON.stringify(retData.body.errorList));
            }
        }
        //}, [selTree, retData, listPath])
    }, [retData, listPath]);
    //////////////////
    // option 선택 시  값 변경 액션
    function selectOptionDateType(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        setDateType(JSON.parse(optionData));
        // init
        // resetSearchCount(false);
    }
    // option 선택 시  값 변경 액션
    function selectOptionDateTerm(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        const dt = JSON.parse(optionData);
        let today = new Date();
        const startdate = new Date(new Date().setDate(today.getDate() - dt.dtVal));
        if (dt.dtVal > 0) {
            setStartDate(startdate);
            setEndDate(today);
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateTerm(dt);
        setDateSel(dt.id);
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var dtDiv = document.querySelector("#mcheck_term__date");
        clog("MOBILE CHECK : DATE TERM : " + dtDiv.clientHeight + " X " + dtDiv.clientWidth);
        var isDtMobile = (dtDiv.clientHeight <= 0) && (dtDiv.clientWidth <= 0) ? true : false;
        if (isDtMobile) { // 검색이 되도록
            setSearchCount({
                "dateType": dateType,
                "dateTerm": dt,
                "startDate": (dt.dtVal > 0) ? startdate : null,
                "endDate": (dt.dtVal > 0) ? today : null,
            });
        }
    }
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        var sf = JSON.parse(optionData);
        if (sf.sfVal.length <= 0)
            setSearchText("");
        setSearchField(JSON.parse(optionData));
        //
    }
    function doSearchCount() {
        setSearchCount({
            /*
            "dateType" : (dateType)?dateType:(searchCount.dateType)?searchCount.dateType:dateTypeList[0],
            "dateTerm" : (dateTerm)?dateTerm:(searchCount.dateTerm)?searchCount.dateTerm:dateTermList[0],
            "startDate" : (startDate)?startDate:searchCount.startDate,
            "endDate" : (endDate)?endDate:searchCount.endDate,
            */
            "dateType": dateType,
            "dateTerm": dateTerm,
            "startDate": startDate,
            "endDate": endDate,
        });
    }
    function onClickSearchCount(e) {
        if (!isCount) {
            if (startDate == null) {
                alert("시작일자를 입력하세요");
            }
            else if (endDate == null) {
                alert("종료일자를 입력하세요");
            }
            else {
                doSearchCount();
            }
        }
        else {
            doSearchCount();
        }
    }
    function onClickSortField(fieldVal) {
        handleCurPage(0);
        setFieldList(fieldList.map(fd => (fd.fdVal === fieldVal)
            ? Object.assign(Object.assign({}, fd), { "sort": (fd.sort === "asc") ? "desc" : "asc", "click": true }) : Object.assign(Object.assign({}, fd), { "sort": "asc", "click": false })) // 단일 필드 정렬만....
        );
    }
    ///
    useEffect(() => {
        setParentPopWin("pop-search-small", React.createElement(MobilePopupSearch, { searchFieldList: searchFieldList, searchField: searchField, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, goSearch: goSearch }));
    }); //re-rendering을 모바일 화면까지 전달하기 위해...
    function onClickSearch(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var schDiv = document.querySelector("#mcheck_searchinput");
        clog("MOBILE CHECK : TEXT SEARCH : " + schDiv.clientHeight + " X " + schDiv.clientWidth);
        var isSchMobile = (schDiv.clientHeight <= 0) && (schDiv.clientWidth <= 0) ? true : false;
        (isSchMobile) && setParentPopWin("pop-search-small", React.createElement(MobilePopupSearch, { searchFieldList: searchFieldList, searchField: searchField, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, goSearch: goSearch }));
        (isSchMobile) && CUTIL.jsopen_m3_Popup(e, isSchMobile);
        (!isSchMobile) && goSearch(e);
        handleCurPage(0);
    }
    function goSearch(e) {
        //clog("goSearch : " + JSON.stringify(searchField));
        handleCurPage(0);
        setSearchData({
            "searchField": searchField,
            "searchText": searchText,
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", style: { "width": `${(isTreeOpen) ? "calc(100% - 320px)" : "calc(100% - 40px)"}` } },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, selTree.company.companyName),
                React.createElement("li", null, selTree.zone.zoneName),
                (selTree.subZone.subZoneId.length > 0) && React.createElement("li", null, selTree.subZone.subZoneName)),
            React.createElement("div", { className: "area__top" },
                React.createElement("div", { className: "search" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("label", { htmlFor: "term", className: "mt-0 " },
                                React.createElement("div", { className: "select noline", onClick: (e) => CUTIL.onClickSelect(e, selectOptionDateType) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, dateType.dtDisp),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, dateTypeList.map((dt, idx) => (React.createElement("li", { key: `dt_${idx.toString()}`, className: "option", "data-value": JSON.stringify(dt) }, dt.dtDisp)))))),
                            React.createElement("div", { className: "input__area ml-8" },
                                React.createElement("div", { className: "searchterm" },
                                    React.createElement("div", { className: "select term__month", onClick: (e) => CUTIL.onClickSelect(e, selectOptionDateTerm) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { id: "mcheck_date", className: "selected-value" }, dateTerm.dtDisp),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, dateTermList.map((dt, idx) => (React.createElement("li", { key: `dt_${idx.toString()}`, id: "mcheck_date_" + dt.id, className: "option", "data-value": JSON.stringify(dt) }, dt.dtDisp))))),
                                    React.createElement("div", { className: "term__date", id: "mcheck_term__date" },
                                        React.createElement(DatePicker, { className: "calendar w91", locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate, 
                                            // minDate={mintStartDate} //기간별 날짜 제한
                                            onChange: (date) => setStartDate(date), onFocus: (e) => e.target.readOnly = true, readOnly: (dateSel != 0) ? true : false }),
                                        React.createElement("span", { className: "centerline" }, "~"),
                                        React.createElement(DatePicker, { className: "calendar w91", locale: (langs === CONST.STR_LANG_CHA) ? zhCN : (langs === CONST.STR_LANG_ENG) ? enUS : ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, 
                                            // maxDate={maxEndDate} //기간별 날짜 제한
                                            onChange: (date) => setEndDate(date), onFocus: (e) => e.target.readOnly = true, readOnly: (dateSel != 0) ? true : false })))))),
                    React.createElement("div", { ref: counteRef, className: "btn__wrap" },
                        React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => onClickSearchCount(e) },
                            React.createElement("span", null, t("LABEL.조회")))))),
            React.createElement("h2", { className: "mb-24" },
                "e-HC Work Order",
                React.createElement("p", { className: "txt-info fontRegular mt-8" }, "* Work Order\uB294 LS\uC77C\uB809\uD2B8\uB9AD\uC758 Engineer\uC5D0\uAC8C e-HC [Premium] , [Advanced] \uC810\uAC80\uC744 \uC694\uCCAD\uD55C \uB0B4\uC5ED\uB9CC \uD45C\uC2DC\uB429\uB2C8\uB2E4.")),
            (ehcCount) &&
                React.createElement("div", { className: "area__right_content" },
                    React.createElement("ul", { className: "checkstatus-box" },
                        React.createElement("li", null,
                            React.createElement("div", { className: (serviceStatus === "") ? "on" : "" },
                                React.createElement("a", { href: "#", onClick: (e) => handleServiceStatus("") },
                                    React.createElement("p", null, t("LABEL.전체")),
                                    React.createElement("p", null,
                                        React.createElement("strong", null, ehcCount.totalCount),
                                        "ea")))),
                        React.createElement("li", null,
                            React.createElement("div", { className: (serviceStatus === "REQUESTED") ? "on" : "" },
                                React.createElement("a", { href: "#", onClick: (e) => handleServiceStatus("REQUESTED") },
                                    React.createElement("p", null, t("LABEL.요청")),
                                    React.createElement("p", null,
                                        React.createElement("strong", null, ehcCount.requestCount),
                                        "ea"))),
                            React.createElement("div", { className: (serviceStatus === "ACCEPTED") ? "on" : "" },
                                React.createElement("a", { href: "#", onClick: (e) => handleServiceStatus("ACCEPTED") },
                                    React.createElement("p", null, t("LABEL.접수")),
                                    React.createElement("p", null,
                                        React.createElement("strong", null, ehcCount.acceptedCount),
                                        "ea"))),
                            React.createElement("div", { className: (serviceStatus === "ING") ? "on" : "" },
                                React.createElement("a", { href: "#", onClick: (e) => handleServiceStatus("ING") },
                                    React.createElement("p", null, t("LABEL.진행중")),
                                    React.createElement("p", null,
                                        React.createElement("strong", null, ehcCount.ingCount),
                                        "ea"))),
                            React.createElement("div", { className: (serviceStatus === "DONE") ? "on" : "" },
                                React.createElement("a", { href: "#", onClick: (e) => handleServiceStatus("DONE") },
                                    React.createElement("p", null, t("LABEL.완료")),
                                    React.createElement("p", null,
                                        React.createElement("strong", null, ehcCount.doneCount),
                                        "ea"))))),
                    React.createElement("div", { className: "tbl__top" },
                        React.createElement("div", { className: "right" },
                            React.createElement("div", { className: "searcharea" },
                                React.createElement("div", { className: "searchinput", id: "mcheck_searchinput" },
                                    React.createElement("span", null, t("LABEL.검색")),
                                    React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, searchField.sfDisp),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.sfDisp))))),
                                    React.createElement("div", { className: "input__direct" },
                                        React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                        (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                            React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")))),
                                React.createElement("button", { type: "button", className: "btn-search js-open-m3", "data-pop": "pop-search-small", onClick: (e) => onClickSearch(e) },
                                    React.createElement("span", null, t("LABEL.조회")))))),
                    React.createElement(EhealthCheckDetailList, { isMobile: isMobile, setIsMobile: props.setIsMobile, appPath: appPath, pageInfo: pageInfo, setPageInfo: setPageInfo, serviceStatus: serviceStatus, searchData: searchData, setNodata: props.setNodata, 
                        // resetSearchCount = {resetSearchCount}
                        handleCurPage: handleCurPage, setPopWin: props.setPopWin })),
            React.createElement(EhpPagination, { componentName: "WORKFLOW-EHC", pageInfo: pageInfo, handleFunc: handleCurPage }))));
}
;
export default EhealthCheckList;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function EhealthCheckDetailList(props) {
    //trans
    const t = useTrans();
    const navigate = useNavigate();
    const mobileRef = useRef(null); // Mobile Check용
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const appPath = props.appPath;
    const pageInfo = props.pageInfo;
    const setParentPageInfo = props.setPageInfo;
    const serviceStatus = props.serviceStatus;
    const searchData = props.searchData;
    const setParentNodata = props.setNodata;
    const resetParentSearchCount = props.resetSearchCount;
    const setParentCurPage = props.handleCurPage;
    const setParentPopWin = props.setPopWin;
    //
    const [ehcList, setEhcList] = useState([]);
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if (!CUTIL.isnull(mobileTag)) {
                if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                    setParentIsMobile(true);
                }
                else {
                    setParentIsMobile(false);
                }
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (mobileRef.current) {
            if ((mobileRef.current.clientHeight <= 0) && (mobileRef.current.clientWidth <= 0)) {
                setParentIsMobile(true);
                var schDiv = document.querySelector("#mcheck_searchinput");
                var isSchMobile = (schDiv.clientHeight <= 0) && (schDiv.clientWidth <= 0) ? true : false;
            }
            else {
                setParentIsMobile(false);
            }
        }
    }), 100, [ehcList]);
    const [fieldList, setFieldList] = useState([
        { "id": 0, "fdDisp": "상태", "fdVal": "progressStatus", "sort": "asc", "click": false },
        { "id": 1, "fdDisp": "점검단계", "fdVal": "ehcStatus", "sort": null, "click": false },
        { "id": 2, "fdDisp": "요청 일자", "fdVal": "requestDate", "sort": "asc", "click": false },
        { "id": 3, "fdDisp": "기기명", "fdVal": "spgName", "sort": "asc", "click": false },
        { "id": 4, "fdDisp": "Panel 명", "fdVal": "panelName", "sort": "asc", "click": false },
        { "id": 5, "fdDisp": "시리얼 번호", "fdVal": "serialNo", "sort": "asc", "click": false },
        { "id": 6, "fdDisp": "담당자", "fdVal": "responsible", "sort": null, "click": false },
        { "id": 7, "fdDisp": "Report", "fdVal": "", "sort": null, "click": false },
        { "id": 8, "fdDisp": "진행 일자", "fdVal": "handlingDate", "sort": "asc", "click": false },
        { "id": 9, "fdDisp": "완료 일자", "fdVal": "completionDate", "sort": "asc", "click": false },
    ]);
    const [errorList, setErrorList] = useState([]);
    //검색 카운트별 검색 전체/요청/...
    let listPath = appPath;
    listPath = listPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (serviceStatus.length > 0) {
        listPath = listPath + `&serviceStatus=${serviceStatus}`;
    }
    //text검색
    if (searchData.searchField) {
        if (searchData.searchField.sfVal.length > 0) {
            listPath = listPath + `&searchKind=${searchData.searchField.sfVal}&searchLike=${searchData.searchText}`;
        }
    }
    //필드 정렬
    fieldList.filter(fd => fd.click && fd.sort).map((fd) => {
        listPath = listPath + `&sort=${fd.fdVal},${fd.sort}`;
    });
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/workorder?${listPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: listPath // + listReload
    });
    useEffect(() => {
        //setRecoilIsLoadingBox(true);
        if (retData) {
            setRecoilIsLoadingBox(false);
            const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
            if (ERR_URL.length > 0) {
                navigate(ERR_URL);
            }
            if (retData.codeNum == CONST.API_200) {
                clog("IN WF EHC LIST : RES : " + JSON.stringify(retData.data.page));
                //setEhcCount(retData.body);
                // resetParentSearchCount(true); // reset
                setEhcList(retData.body);
                setParentPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false })); //5, 10
                setParentNodata(retData.data.page.totalElements);
            }
            else { // api if
                // need error handle -> goto system error page?
                setErrorList(retData.body.errorList);
                alert(JSON.stringify(retData.body.errorList));
            }
        }
        //}, [selTree, retData, listPath])
    }, [retData]);
    function onClickSortField(fieldVal) {
        setParentCurPage(0);
        setFieldList(fieldList.map(fd => (fd.fdVal === fieldVal)
            ? Object.assign(Object.assign({}, fd), { "sort": (fd.sort === "asc") ? "desc" : "asc", "click": true }) : Object.assign(Object.assign({}, fd), { "sort": "asc", "click": false })) // 단일 필드 정렬만....
        );
    }
    // PDF 다운로드
    function onClickReportDownload(ehc) {
        HTTPUTIL.fileDownload_EhcReport(ehc.itemName, ehc.assessment.reportId, userInfo.loginInfo.token);
    }
    function onClickEhcDetailView(e, ehc) {
        // search 기준으로 모바일 태블릿 check
        var schDiv = document.querySelector("#mcheck_searchinput");
        var isSchMobile = (schDiv.clientHeight <= 0) && (schDiv.clientWidth <= 0) ? true : false;
        if (!isSchMobile) {
            var popupVal = e.target.getAttribute("data-pop");
            if (CUTIL.isnull(popupVal))
                e.target.setAttribute("data-pop", "pop-list-ehcdetailview");
            popupVal = e.target.getAttribute("data-ds-height");
            if (CUTIL.isnull(popupVal))
                e.target.setAttribute("data-ds-height", "496");
        }
        setParentPopWin("pop-list-ehcdetailview", React.createElement(MobileEhcDetailView, { htmlHeader: React.createElement("h1", null,
                "e-HC Work Order ",
                t("LABEL.상세정보")), ehcInfo: ehc, setPopWin: props.setPopWin }));
        CUTIL.jsopen_m2_Popup(e, isMobile);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "nodata__txt " }, t("MESSAGE.데이터를찾을수없습니다")),
        React.createElement("div", { className: "tbl-list hcal-vh-560" },
            React.createElement("table", { summary: "\uC0C1\uD0DC,\uC810\uAC80\uB2E8\uACC4,\uC694\uCCAD \uC77C\uC790,\uC811\uC218\uBC88\uD638, SPG \uBA85,Panel \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uB2F4\uB2F9\uC790,\uC810\uAC80\uC77C\uC790,Step,Report,\uC9C4\uD589 \uC77C\uC790,\uC644\uB8CC \uC77C\uC790 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C e-HC Work Order List \uC785\uB2C8\uB2E4." },
                React.createElement("caption", null, "e-HC Work Order List"),
                React.createElement("colgroup", null,
                    React.createElement("col", { style: {} })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "progressStatus").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("progressStatus") },
                            React.createElement("span", null, t("FIELD.상태"))),
                        React.createElement("th", { scope: "col", className: "d-sm-none txt-left" },
                            React.createElement("span", null, t("FIELD.점검단계"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "requestDate").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left d-sm-none`, onClick: (e) => onClickSortField("requestDate") },
                            React.createElement("span", null, t("FIELD.요청일자"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "spgName").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("spgName") },
                            React.createElement("span", null, t("FIELD.기기명"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "panelName").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} txt-left`, onClick: (e) => onClickSortField("panelName") },
                            React.createElement("span", null, t("FIELD.Panel명"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "serialNo").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} d-sm-none txt-left`, onClick: (e) => onClickSortField("serialNo") },
                            React.createElement("span", null, t("FIELD.시리얼번호"))),
                        React.createElement("th", { scope: "col", className: "d-lm-none d-sm-none txt-left", ref: mobileRef },
                            React.createElement("span", null, t("FIELD.담당자"))),
                        React.createElement("th", { scope: "col", className: "d-lm-none d-sm-none" },
                            React.createElement("span", null, t("FIELD.Report"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "handlingDate").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} d-lm-none d-sm-none txt-left`, onClick: (e) => onClickSortField("handlingDate") },
                            React.createElement("span", null, t("FIELD.진행일자"))),
                        React.createElement("th", { scope: "col", className: `${fieldList.filter(fd => fd.fdVal === "completionDate").map(fd => (fd.sort) ? `sort ${fd.sort}` : "")} d-lm-none d-sm-none txt-left`, onClick: (e) => onClickSortField("completionDate") },
                            React.createElement("span", null, t("FIELD.완료일자"))))),
                React.createElement("tbody", null, ehcList.map((ehc, idx) => (React.createElement("tr", { key: `tr_${idx.toString()}`, className: "js-open-m2", "data-pop": "pop-list-ehcdetailview" /*pop-list-view*/, onClick: (e) => onClickEhcDetailView(e, ehc) },
                    React.createElement("td", { className: "txt-left d-sm-none" }, ehc.progressStatus),
                    React.createElement("td", { className: "d-sm-none txt-left" },
                        React.createElement("img", { src: require(`/static/img/icon_${(ehc.ehcStatus) ? ehc.ehcStatus[0].toLowerCase() : "x"}.png`), style: { "width": "24px", "height": "24px" }, alt: ehc.ehcStatus })),
                    React.createElement("td", { className: "txt-left d-sm-none" }, (ehc.requestDate) ? CUTIL.utc2formedstr(ehc.requestDate, "YYYY-MM-DD") : "-"),
                    React.createElement("td", { className: "txt-left" }, ehc.spg.spgName),
                    React.createElement("td", { className: "txt-left" },
                        React.createElement("p", { className: "ellipsis" }, ehc.panel.panelName)),
                    React.createElement("td", { className: "d-sm-none txt-left" },
                        React.createElement("p", { className: "ellipsis" }, (ehc.serialNo) ? ehc.serialNo : "-")),
                    React.createElement("td", { className: "d-lm-none d-sm-none txt-left" }, ehc.responsible),
                    React.createElement("td", { className: "d-lm-none d-sm-none" },
                        React.createElement("button", { type: "button", className: "btn btn-file", onClick: (e) => onClickReportDownload(ehc) },
                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uB2E4\uC6B4\uB85C\uB4DC"))),
                    React.createElement("td", { className: "d-lm-none d-sm-none txt-left" }, (ehc.handlingDate) ? CUTIL.utc2formedstr(ehc.handlingDate, "YYYY-MM-DD") : "-"),
                    React.createElement("td", { className: "d-lm-none d-sm-none txt-left" }, (ehc.completionDate) ? CUTIL.utc2formedstr(ehc.completionDate, "YYYY-MM-DD") : "-")))))))));
}
function MobileEhcDetailView(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const ehc = props.ehcInfo;
    const setParentPopWin = props.setPopWin;
    // PDF 다운로드
    function onClickReportDownload(ehc) {
        HTTPUTIL.fileDownload_EhcReport(ehc.itemName, ehc.assessment.reportId, userInfo.loginInfo.token);
    }
    function onClickClose(e) {
        CUTIL.jsclose_Popup("pop-list-ehcdetailview");
        setParentPopWin("pop-list-ehcdetailview", null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uB9AC\uC2A4\uD2B8 \uC0C1\uC138 \uC815\uBCF4"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.상태")),
                            React.createElement("p", { className: "txt" }, ehc.progressStatus)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.점검단계")),
                            React.createElement("p", { className: "txt" },
                                React.createElement("img", { src: require(`/static/img/icon_${(ehc.ehcStatus) ? ehc.ehcStatus[0].toLowerCase() : "x"}.png`), style: { "width": "24px", "height": "24px" }, alt: ehc.ehcStatus }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.요청일자")),
                            React.createElement("p", { className: "txt" }, (ehc.requestDate) ? CUTIL.utc2formedstr(ehc.requestDate, "YYYY-MM-DD") : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.기기명")),
                            React.createElement("p", { className: "txt" }, ehc.spg.spgName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.Panel명")),
                            React.createElement("p", { className: "txt" }, ehc.panel.panelName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.시리얼번호")),
                            React.createElement("p", { className: "txt" }, (ehc.serialNo) ? ehc.serialNo : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.담당자")),
                            React.createElement("p", { className: "txt" }, ehc.responsible)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.Report")),
                            React.createElement("div", { className: "txt" },
                                React.createElement("ul", { className: "filelist" },
                                    React.createElement("li", null,
                                        React.createElement("span", null, "PDF"),
                                        React.createElement("button", { type: "button", className: "btn btn-filedown", onClick: (e) => onClickReportDownload(ehc) },
                                            React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.진행일자")),
                            React.createElement("p", { className: "txt" }, (ehc.handlingDate) ? CUTIL.utc2formedstr(ehc.handlingDate, "YYYY-MM-DD") : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.완료일자")),
                            React.createElement("p", { className: "txt" }, (ehc.completionDate) ? CUTIL.utc2formedstr(ehc.completionDate, "YYYY-MM-DD") : "-")))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "js-close", onClick: (e) => onClickClose(e) },
                        React.createElement("span", null, t("LABEL.확인"))))))));
}
function MobilePopupSearch(props) {
    //trans
    const t = useTrans();
    //props
    const searchFieldList = props.searchFieldList;
    const searchField = props.searchField;
    const setParentSearchField = props.setSearchField;
    const searchText = props.searchText;
    const setParentSearchText = props.setSearchText;
    const goSearch = props.goSearch;
    //const [searchText, setSearchText] = useState("");
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        var sf = JSON.parse(optionData);
        if (sf.sfVal.length <= 0)
            setParentSearchText("");
        //if ( sf.sfVal.length <= 0 ) setSearchText("");
        setParentSearchField(sf);
        //
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
    }
    function handleGoSearch(e) {
        goSearch(e);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "form__input mb-0" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value" }, searchField.sfDisp),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.sfDisp))))),
                React.createElement("div", { className: "input__direct" },
                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setParentSearchText(e.target.value) }),
                    (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setParentSearchText("") },
                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", onClick: (e) => handleGoSearch(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
